import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { notificationController } from "components/common/notificationController";
import { loadState } from "library/helpers/sessionStorage";
import { FETCH_ALL_USERS_REQUEST } from "./actionsTypes";
import {
  fetchAllUsersRequest,
  fetchAllUsersSuccess,
  fetchAllUsersFailure,
} from "./actions";
import { AllUsers } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const getRequest = async (url: string) => {
  const { data } = await apiService.get(url, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchAllUsersSaga(action: ReturnType<typeof fetchAllUsersRequest>) {
  try {
    const response: AllUsers[] = yield call(getRequest, action.url);
    yield put(fetchAllUsersSuccess(response));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchAllUsersFailure(errorMessage));

    if (errorMessage && error?.response?.status !== 401) {
      notificationController.error({
        message: "Error",
        description: `Error fetching All Users: ${errorMessage}`,
      });
    }
  }
}
export default function* allUsersSaga() {
  yield takeLatest(FETCH_ALL_USERS_REQUEST, fetchAllUsersSaga);
}
